import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';
import routes from 'src/routes';
import Page from 'src/components/Page';
import SequenceDiagram from 'src/components/SequenceDiagram';
import Checkbox from 'src/components/Checkbox';
import RadioGroup from 'src/components/RadioGroup';
import Columns from 'src/components/Columns';
import './TokenAuthkeyPage.scss';

const actors = [
    {
        name: "Customer's Browser"
    },
    {
        name: "Merchant"
    },
    {
        name: "BPOINT"
    }
];

function TokenAuthkeyPage() {

    const [flowMethod, setFlowMethod] = useState('add');
    const [paymentMethod, setPaymentMethod] = useState('2party-authkey');
    const [includeTokenDetails, setIncludeTokenDetails] = useState(false);

    const is2PartyOnly = paymentMethod === '2party';

    let paymentMethodInteraction;
    switch (paymentMethod) {
        case '2party-authkey':
            paymentMethodInteraction = [
                {
                    start: 1,
                    end: 2,
                    text: <Link to={routes.api.spec + "#operation/TokenAuthkey_AttachPaymentMethod"}>Attach card/bank account</Link>,
                    includeReturn: true,
                },
            ];
            break;
        case "javascriptSimple":
            paymentMethodInteraction = [
                {
                    start: 0,
                    end: 1,
                    text: 'Authkey',
                    backwards: true,
                },
                {
                    start: 0,
                    end: 2,
                    text: <Link to={routes.api.token.authkey.javascriptSimple}>Setup payment method form</Link>,
                    includeReturn: true,
                },
                {
                    start: 0,
                    end: 2,
                    text: 'User enters and submits card details',
                    includeReturn: true,
                },
                {
                    start: 0,
                    end: 1,
                    text: 'Payment method complete'
                }
            ];
            break;
        case 'javascriptAdvanced':
            paymentMethodInteraction = [
                {
                    start: 0,
                    end: 1,
                    text: 'Authkey',
                    backwards: true,
                },
                {
                    start: 0,
                    end: 2,
                    text: <HashLink to={routes.api.token.authkey.javascriptAdvanced}>Attach card/bank account</HashLink>,
                    includeReturn: true
                },
                {
                    start: 0,
                    end: 1,
                    text: 'Payment method complete',
                },
            ]
            break;
        case 'iframeFields':
            paymentMethodInteraction = [
                {
                    start: 0,
                    end: 1,
                    text: 'Authkey',
                    backwards: true,
                },
                {
                    start: 0,
                    end: 2,
                    text: <HashLink to={routes.api.token.authkey.iframeFields}>Create payment method form</HashLink>,
                    includeReturn: true
                },
                {
                    start: 0,
                    end: 2,
                    text: <HashLink to={routes.api.token.authkey.iframeFields}>Submit payment method</HashLink>,
                    includeReturn: true
                },
                {
                    start: 0,
                    end: 1,
                    text: 'Payment method complete',
                },
            ]
            break;
        default:
            paymentMethodInteraction = [];
            break;
    }

    let interactions = [];

    if (is2PartyOnly) {

        interactions = [
            {
                text: "Initiate payment",
                start: 0,
                end: 1,
            },
            ...(flowMethod === 'add' ? [{
                start: 1,
                end: 2,
                text: <Link to={routes.api.spec + "#operation/Token_AddToken"}>Add new token</Link>,
                includeReturn: true,
            }] : [{
                start: 1,
                end: 2,
                text: <Link to={routes.api.spec + "#operation/Token_UpdateToken"}>Update token</Link>,
                includeReturn: true,
            }]),
            {
                start: 0,
                end: 1,
                text: 'Receipt page',
                backwards: true,
            }];

    } else {

        interactions = [
            {
                text: "Initiate payment",
                start: 0,
                end: 1,
            },
            {
                start: 1,
                end: 2,
                text: <Link to={routes.api.spec + "#operation/TokenAuthkey_CreateAuthkey"}>Create authkey</Link>,
                includeReturn: true,
            },
            ...(flowMethod === 'add' || includeTokenDetails ? [{
                start: 1,
                end: 2,
                text: <Link to={routes.api.spec + "#operation/TokenAuthkey_AttachTokenDetails"}>Attach token details</Link>,
                includeReturn: true,
            }] : []),
            ...paymentMethodInteraction,
            {
                start: 1,
                end: 2,
                text: <Link to={routes.api.spec + "#operation/TokenAuthkey_Process"}>Process</Link>,
                includeReturn: true,
            },
            {
                start: 0,
                end: 1,
                text: 'Receipt page',
                backwards: true,
            },
        ];
    }

    return <Page header="Token flow">
        <div class="container">
            <p class="hidden-text">
                The sequence diagram demonstrates the flow for each token method.
            </p>
        </div>

        <h2>Flow</h2>

        <RadioGroup value={flowMethod} onChange={setFlowMethod} options={{
            'add': 'Add token',
            'update': 'Update token',
        }} />
        <Columns >
            <div className="token-auth-key-columns">
                <h3>Payment Method</h3>
                <RadioGroup value={paymentMethod} onChange={setPaymentMethod} options={{
                    '2party': '2 Party',
                    '2party-authkey': '2 Party - AuthKey',
                    javascriptSimple: '3 Party - JavaScript Simple',
                    javascriptAdvanced: '3 Party - JavaScript Advanced',
                    'iframeFields': '3 Party - Iframe Fields'
                }} />
            </div>
            {!is2PartyOnly && flowMethod === 'update' &&
                <div>
                    <h3>Options</h3>
                    <Checkbox label="Update token details" checked={includeTokenDetails} onChange={setIncludeTokenDetails} />
                </div>
            }
        </Columns>

        <SequenceDiagram actors={actors} interactions={interactions} />
    </Page>
}

export default TokenAuthkeyPage;